// New updated code

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import gstStates from "gst-states";

// function UpdateLedger() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   // ✅ Pre-fill data from clicked ledger
//   const initialData = location.state?.ledgerData || {};
//   const [formData, setFormData] = useState(initialData);
//   const [loading, setLoading] = useState(false);

//   // Dropdown data
//   const [allGroups, setAllGroups] = useState([]);
//   const [allLedgers, setAllLedgers] = useState([]);
//   const [allStates, setAllStates] = useState([]); // for state dropdown
//   const [selectedLedgerName, setSelectedLedgerName] = useState(initialData?.LedgerName || "");

//   useEffect(() => {
//     console.log("📩 Initial ledger data received:", initialData);

//     // Pre-fill form data with normalized StateID
//     setFormData({
//       ...initialData,
//       HEAD_CODE: initialData.HEAD_CODE ? String(initialData.HEAD_CODE) : "",
//       GroupCODE: initialData.GroupCODE ? String(initialData.GroupCODE) : "",
//       StateID: initialData.StateID ? String(initialData.StateID).padStart(2, "0") : "", // normalize
//     });
//     setSelectedLedgerName(initialData?.LedgerName || "");

//     // Prepare state options
//     const statesArray = Object.entries(gstStates)
//       .map(([code, name]) => ({ code: String(code).padStart(2, "0"), name }))
//       .sort((a, b) => parseInt(a.code) - parseInt(b.code));
//     setAllStates(statesArray);

//     const fetchDropdowns = async () => {
//       try {
//         const res = await fetch("http://localhost:5000/api/ledger/dropdowns");
//         const data = await res.json();

//         console.log("✅ Dropdown data fetched:", data);

//         // Sort Ledgers alphabetically
//         setAllLedgers(
//           data.ledgers.sort((a, b) =>
//             a.HEADName.localeCompare(b.HEADName, undefined, { numeric: true })
//           )
//         );

//         // Sort Groups alphabetically
//         setAllGroups(
//           data.groups.sort((a, b) =>
//             a.GroupNAME.localeCompare(b.GroupNAME, undefined, { numeric: true })
//           )
//         );
//       } catch (err) {
//         console.error("❌ Failed to fetch dropdown data:", err);
//       }
//     };

//     fetchDropdowns();
//   }, [initialData]);

//   // Generic form field change
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // Ledger dropdown change
//   const handleLedgerChange = (e) => {
//     const selectedHeadCode = e.target.value;
//     const selectedLedger = allLedgers.find(
//       (l) => String(l.HEAD_CODE) === String(selectedHeadCode)
//     );

//     setFormData((prev) => ({
//       ...prev,
//       HEAD_CODE: selectedHeadCode,
//     }));

//     setSelectedLedgerName(selectedLedger?.HEADName || "");
//   };

//   // Group dropdown change
//   const handleGroupChange = (e) => {
//     const selectedGroupCode = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       GroupCODE: selectedGroupCode,
//     }));
//   };

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!formData.HEAD_CODE) {
//     toast.warn("Ledger selection is required.");
//     return;
//   }

//   // ✅ Validate StateID vs GST No
//   if (formData.StateID && formData.GSTNO) {
//     const gstFirstTwo = formData.GSTNO.substring(0, 2);
//     if (gstFirstTwo !== formData.StateID.toString()) {
//       toast.error("❌ State ID and GST No must match in first two digits.");
//       return;
//     }
//   }

//   setLoading(true);
//   try {
//     const { HEAD_CODE, ...updateData } = formData; // exclude HEAD_CODE from body
//     const response = await fetch(
//       `http://localhost:5000/api/ledger/${HEAD_CODE}`, // use HEAD_CODE in URL
//       {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...updateData,
//           OwnerName: selectedLedgerName, // map ledger name
//         }),
//       }
//     );

//     const data = await response.json();

//     if (response.ok) {
//       toast.success(data.message || "✅ Ledger updated successfully!");
//       setTimeout(() => {
//         navigate("/ShowLedger", {
//           state: { updatedLedger: formData },
//         });
//       }, 1500);
//     } else {
//       toast.error(data.error || "❌ Failed to update ledger.");
//     }
//   } catch (err) {
//     console.error("Update Ledger Error:", err);
//     toast.error("❌ Network or server error.");
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div className="compney_container mb-5">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Ledger</h5>

//         {/* Ledger Name Dropdown */}
//         <div className="compney_input_div">
//           <label>Ledger Name</label>
//           <select
//             name="HEAD_CODE"
//             value={formData.HEAD_CODE || ""}
//             onChange={handleLedgerChange}
//           >
//             <option value="">Select Ledger</option>
//             {allLedgers.map((ledger) => (
//               <option key={ledger.HEAD_CODE} value={String(ledger.HEAD_CODE)}>
//                 {ledger.HEADName} ({ledger.HEAD_CODE})
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Opening Balance */}
//         <div className="compney_input_div">
//           <label>Opening Balance</label>
//           <input
//             type="number"
//             name="OpeningBal"
//             value={formData.OpeningBal || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Open Balance Type */}
//         <div className="compney_input_div">
//           <label>Open Balance Type</label>
//           <select
//             name="OpenBlType"
//             value={formData.OpenBlType || ""}
//             onChange={handleChange}
//           >
//             <option value="">Select Type</option>
//             <option value="Dr">Dr</option>
//             <option value="Cr">Cr</option>
//           </select>
//         </div>

//         {/* Bill by Bill */}
//         <div className="compney_input_div">
//           <label>Bill by Bill</label>
//           <select
//             name="BillbyBill"
//             value={formData.BillbyBill ? "Yes" : "No"}
//             onChange={(e) =>
//               setFormData((prev) => ({
//                 ...prev,
//                 BillbyBill: e.target.value === "Yes",
//               }))
//             }
//           >
//             <option value="Yes">Yes</option>
//             <option value="No">No</option>
//           </select>
//         </div>

//         {/* Group Name Dropdown */}
//         <div className="compney_input_div">
//           <label>Group Name</label>
//           <select
//             name="GroupCODE"
//             value={formData.GroupCODE || ""}
//             onChange={handleGroupChange}
//           >
//             <option value="">Select Group</option>
//             {allGroups.map((group) => (
//               <option key={group.GroupCODE} value={String(group.GroupCODE)}>
//                 {group.GroupNAME} ({group.GroupCODE})
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Closing Balance */}
//         <div className="compney_input_div">
//           <label>Closing Balance</label>
//           <input
//             type="number"
//             name="CL_BALANCE"
//             value={formData.CL_BALANCE || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Address Fields */}
//         <div className="compney_input_div">
//           <label>Address 1</label>
//           <input
//             type="text"
//             name="ADDRESS1"
//             value={formData.ADDRESS1 || ""}
//             onChange={handleChange}
//           />
//         </div>
//         <div className="compney_input_div">
//           <label>Address 2</label>
//           <input
//             type="text"
//             name="ADDRESS2"
//             value={formData.ADDRESS2 || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Contact Info */}
//         <div className="compney_input_div">
//           <label>Phone</label>
//           <input
//             type="text"
//             name="PHONE"
//             value={formData.PHONE || ""}
//             onChange={handleChange}
//           />
//         </div>
//         <div className="compney_input_div">
//           <label>Mobile</label>
//           <input
//             type="text"
//             name="MOBILE"
//             value={formData.MOBILE || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* PAN & Email */}
//         <div className="compney_input_div">
//           <label>PAN No</label>
//           <input
//             type="text"
//             name="PANNO"
//             value={formData.PANNO || ""}
//             onChange={handleChange}
//           />
//         </div>
//         <div className="compney_input_div">
//           <label>Email</label>
//           <input
//             type="email"
//             name="EMAIL"
//             value={formData.EMAIL || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* GST No */}
//         <div className="compney_input_div">
//           <label>GST No</label>
//           <input
//             type="text"
//             name="GSTNO"
//             value={formData.GSTNO || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* State Dropdown */}
//         <div className="compney_input_div">
//           <label>State</label>
//           <select
//             name="StateID"
//             value={formData.StateID || ""}
//             onChange={handleChange}
//           >
//             <option value="">Select State</option>
//             {allStates.map((state) => (
//               <option key={state.code} value={state.code}>
//                 {state.name} ({state.code})
//               </option>
//             ))}
//           </select>
//         </div>

//         <button type="submit" disabled={loading}>
//           {loading ? "Updating..." : "Save Changes"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default UpdateLedger;


// its old code dont delete it 


// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function UpdateLedger() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   // ✅ Pre-fill data from clicked ledger
//   const initialData = location.state?.ledgerData || {};
//   const [formData, setFormData] = useState(initialData);
//   const [loading, setLoading] = useState(false);

//   // Dropdown data
//   const [allGroups, setAllGroups] = useState([]); 
//   const [allStates, setAllStates] = useState([]); // ✅ only states

//   useEffect(() => {
//     console.log("📩 Initial ledger data received:", initialData);

//     setFormData({
//       ...initialData,
//       HEAD_CODE: initialData.HEAD_CODE ? String(initialData.HEAD_CODE) : "",
//       GroupCODE: initialData.GroupCODE ? String(initialData.GroupCODE) : "",
//       StateID: initialData.StateID ? String(initialData.StateID) : "",
//       LedgerName: initialData.LedgerName || "",
//     });

//     const fetchDropdowns = async () => {
//       try {
//         const res = await fetch("http://localhost:5000/api/ledger/dropdowns");
//         const data = await res.json();

//         console.log("✅ Dropdown data fetched:", data);

//         setAllGroups(
//           data.groups.sort((a, b) =>
//             a.GroupNAME.localeCompare(b.GroupNAME, undefined, { numeric: true })
//           )
//         );

//         setAllStates(
//           data.states.sort((a, b) =>
//             a.name.localeCompare(b.name, undefined, { numeric: true })
//           )
//         );
//       } catch (err) {
//         console.error("❌ Failed to fetch dropdown data:", err);
//         toast.error("Failed to load dropdown data.");
//       }
//     };

//     fetchDropdowns();
//   }, [initialData]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     let newValue = type === "checkbox" ? checked : value;

//     if (name === "GSTNO") {
//       newValue = newValue.toUpperCase();
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: newValue,
//     }));
//   };

//   const handleLedgerNameChange = (e) => {
//     const value = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       LedgerName: value,
//     }));
//   };

//   const handleGroupChange = (e) => {
//     const selectedGroupCode = e.target.value;
//     setFormData((prev) => ({
//       ...prev,
//       GroupCODE: selectedGroupCode,
//     }));
//   };

//   const validateGST = () => {
//     if (!formData.GSTNO) return true;
//     const gst = formData.GSTNO.toUpperCase();

//     if (gst.length !== 15) {
//       toast.error("❌ GST number must be exactly 15 characters.");
//       return false;
//     }

//     const selectedState = allStates.find(
//       (state) => String(state.id) === String(formData.StateID)
//     );
//     if (!selectedState) {
//       toast.error("❌ Please select a valid State before entering GST.");
//       return false;
//     }

//     const gstCode = gst.substring(0, 2);
//     if (gstCode !== String(selectedState.code)) {
//       toast.error(
//         `❌ GST number must start with "${selectedState.code}" for state "${selectedState.name}".`
//       );
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.HEAD_CODE) {
//       toast.warn("Ledger selection is required.");
//       return;
//     }

//     if (!validateGST()) return;

//     setLoading(true);
//     try {
//       const { HEAD_CODE, ...updateData } = formData;

//       const response = await fetch(`http://localhost:5000/api/ledger/${HEAD_CODE}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(updateData),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         toast.success(data.message || "✅ Ledger updated successfully!");
        
//         // ✅ Navigate to ShowLedger and pass only the updated ledger
//         setTimeout(() => {
//           navigate("/ShowLedger", {
//             state: { updatedLedger: formData },
//           });
//         }, 1500);
//       } else {
//         toast.error(data.error || "❌ Failed to update ledger.");
//       }
//     } catch (err) {
//       console.error("Update Ledger Error:", err);
//       toast.error("❌ Network or server error.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="compney_container mb-5">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Ledger</h5>

//         <div className="compney_input_div">
//           <label>Ledger Name</label>
//           <input
//             type="text"
//             name="LedgerName"
//             value={formData.LedgerName || ""}
//             onChange={handleLedgerNameChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Opening Balance</label>
//           <input
//             type="number"
//             name="OpeningBal"
//             value={formData.OpeningBal || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Open Balance Type</label>
//           <select
//             name="OpenBlType"
//             value={formData.OpenBlType || ""}
//             onChange={handleChange}
//           >
//             <option value="">Select Type</option>
//             <option value="Dr">Dr</option>
//             <option value="Cr">Cr</option>
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label>Bill by Bill</label>
//           <select
//             name="BillbyBill"
//             value={formData.BillbyBill ? "Yes" : "No"}
//             onChange={(e) =>
//               setFormData((prev) => ({
//                 ...prev,
//                 BillbyBill: e.target.value === "Yes",
//               }))
//             }
//           >
//             <option value="Yes">Yes</option>
//             <option value="No">No</option>
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label>Group Name</label>
//           <select
//             name="GroupCODE"
//             value={formData.GroupCODE || ""}
//             onChange={handleGroupChange}
//           >
//             <option value="">Select Group</option>
//             {allGroups
//               .sort((a, b) => a.GroupNAME.localeCompare(b.GroupNAME))
//               .map((group) => (
//                 <option key={group.GroupCODE} value={String(group.GroupCODE)}>
//                   {group.GroupNAME}
//                 </option>
//               ))}
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label>Address 1</label>
//           <input
//             type="text"
//             name="ADDRESS1"
//             value={formData.ADDRESS1 || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Address 2</label>
//           <input
//             type="text"
//             name="ADDRESS2"
//             value={formData.ADDRESS2 || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Phone</label>
//           <input
//             type="text"
//             name="PHONE"
//             value={formData.PHONE || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Mobile</label>
//           <input
//             type="text"
//             name="MOBILE"
//             value={formData.MOBILE || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>PAN No</label>
//           <input
//             type="text"
//             name="PANNO"
//             value={formData.PANNO || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Email</label>
//           <input
//             type="email"
//             name="EMAIL"
//             value={formData.EMAIL || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>GST No</label>
//           <input
//             type="text"
//             name="GSTNO"
//             maxLength={15}
//             value={formData.GSTNO || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>State</label>
//           <select
//             name="StateID"
//             value={formData.StateID || ""}
//             onChange={handleChange}
//           >
//             <option value="">Select State</option>
//             {allStates
//               .sort((a, b) => a.name.localeCompare(b.name))
//               .map((state) => (
//                 <option key={state.id} value={state.id}>
//                   {state.name} ({state.id})
//                 </option>
//               ))}
//           </select>
//         </div>

//         <button type="submit" disabled={loading}>
//           {loading ? "Updating..." : "Save Changes"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default UpdateLedger;




// add here the global key and data append

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import "./UpdateLedger.css";
import { apiWithLog } from "../../../utils/apiWithLog";

function UpdateLedger() {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Pre-fill data from clicked ledger
  const initialData = location.state?.ledgerData || {};
  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  // Dropdown data
  const [allGroups, setAllGroups] = useState([]);
  const [allStates, setAllStates] = useState([]);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  const cleanStr = (val) => {
    if (val == null) return "";
    return String(val).replace(/^["'“”`\s]+|["'“”`\s]+$/g, "").trim();
  };

  useEffect(() => {
    setFormData({
      ...initialData,
      HEAD_CODE: initialData.HEAD_CODE ? String(initialData.HEAD_CODE) : "",
      GroupCODE: initialData.GroupCODE ? String(initialData.GroupCODE) : "",
      StateID: initialData.StateID ? String(initialData.StateID) : "",
      LedgerName: cleanStr(initialData.LedgerName),
      ADDRESS1: cleanStr(initialData.ADDRESS1),
      ADDRESS2: cleanStr(initialData.ADDRESS2),
      PHONE: cleanStr(initialData.PHONE),
      MOBILE: cleanStr(initialData.MOBILE),
      PANNO: cleanStr(initialData.PANNO),
      EMAIL: cleanStr(initialData.EMAIL),
      GSTNO: cleanStr(initialData.GSTNO),
    });

    const fetchDropdowns = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_API_URL}/ledger/dropdowns`);
        const data = await response.json();

        if (data.success) {
          setAllGroups(
            data.groups?.sort((a, b) =>
              a.GroupNAME.localeCompare(b.GroupNAME, undefined, { numeric: true })
            ) || []
          );

          setAllStates(
            data.states?.sort((a, b) =>
              a.name.localeCompare(b.name, undefined, { numeric: true })
            ) || []
          );
        } else {
          showToast.error("Failed to load dropdown data");
        }
      } catch (err) {
        console.error("Error fetching dropdowns:", err);
        showToast.error("Failed to load dropdown data.");
      } finally {
        setLoading(false);
      }
    };

    fetchDropdowns();
  }, [initialData, BASE_API_URL]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if (name === "GSTNO") {
      newValue = newValue.toUpperCase();
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleLedgerNameChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      LedgerName: value,
    }));
  };

  const handleGroupChange = (e) => {
    const selectedGroupCode = e.target.value;
    setFormData((prev) => ({
      ...prev,
      GroupCODE: selectedGroupCode,
    }));
  };

  const validateGST = () => {
    if (!formData.GSTNO) return true;
    const gst = formData.GSTNO.toUpperCase();

    if (gst.length !== 15) {
      showToast.error("GST number must be exactly 15 characters.");
      return false;
    }

    const selectedState = allStates.find(
      (state) => String(state.id) === String(formData.StateID)
    );
    if (!selectedState) {
      showToast.error("Please select a valid State before entering GST.");
      return false;
    }

    const gstCode = gst.substring(0, 2);
    if (gstCode !== String(selectedState.code)) {
      showToast.error(
        `GST number must start with "${selectedState.code}" for state "${selectedState.name}".`
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.HEAD_CODE) {
      showToast.warn("Ledger selection is required.");
      return;
    }

    if (!formData.LedgerName?.trim()) {
      showToast.warn("Ledger Name is required.");
      return;
    }

    if (!validateGST()) return;

    setLoading(true);
    try {
      const { HEAD_CODE, ...rawUpdateData } = formData;
      const updateData = {
        ...rawUpdateData,
        LedgerName: cleanStr(rawUpdateData.LedgerName),
        ADDRESS1: cleanStr(rawUpdateData.ADDRESS1),
        ADDRESS2: cleanStr(rawUpdateData.ADDRESS2),
        PHONE: cleanStr(rawUpdateData.PHONE),
        MOBILE: cleanStr(rawUpdateData.MOBILE),
        PANNO: cleanStr(rawUpdateData.PANNO),
        EMAIL: cleanStr(rawUpdateData.EMAIL),
        GSTNO: cleanStr(rawUpdateData.GSTNO),
      };

      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/ledger/${HEAD_CODE}`,
        data: updateData,
        module: "LedgerMaster",
        action: "E",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data || {};

      if (res.status >= 200 && res.status < 300) {
        showToast.save(result.message || "Ledger updated successfully!");

        setTimeout(() => {
          navigate("/ShowLedger", {
            state: { updatedLedger: formData },
          });
        }, 1200);
      } else {
        showToast.error(result.error || "Failed to update ledger.");
      }
    } catch (err) {
      console.error("Update Ledger Error:", err);
      showToast.error(
        err?.response?.data?.error || "Network or server error."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">

      {/* HEADER & BREADCRUMBS (NO ICONS) */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h6 className="update_ledger_title">Update Ledger</h6>
          <div className="update_ledger_breadcrumbs">
            <Link to="/">Dashboard</Link>
            <span>&gt;</span>
            <Link to="/ShowLedger">Ledger Master</Link>
            <span>&gt;</span>
            <span>Update Ledger</span>
          </div>
        </div>
      </div>

      {/* FORM CARD */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Edit Ledger Details</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            {/* Ledger Name */}
            <div className="update_ledger_field span_2">
              <label htmlFor="LedgerName">
                Ledger Name <span className="required">*</span>
              </label>
              <input
                id="LedgerName"
                type="text"
                name="LedgerName"
                placeholder="Enter ledger name"
                value={formData.LedgerName || ""}
                onChange={handleLedgerNameChange}
                required
              />
            </div>

            {/* Group Name */}
            <div className="update_ledger_field">
              <label htmlFor="GroupCODE">
                Group Name <span className="required">*</span>
              </label>
              <select
                id="GroupCODE"
                name="GroupCODE"
                value={formData.GroupCODE || ""}
                onChange={handleGroupChange}
                required
              >
                <option value="">-- Select Group --</option>
                {allGroups.map((group) => (
                  <option key={group.GroupCODE} value={String(group.GroupCODE)}>
                    {group.GroupNAME}
                  </option>
                ))}
              </select>
            </div>

            {/* State */}
            <div className="update_ledger_field">
              <label htmlFor="StateID">State</label>
              <select
                id="StateID"
                name="StateID"
                value={formData.StateID || ""}
                onChange={handleChange}
              >
                <option value="">-- Select State --</option>
                {allStates.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name} ({state.code})
                  </option>
                ))}
              </select>
            </div>

            {/* Opening Balance */}
            <div className="update_ledger_field">
              <label htmlFor="OpeningBal">Opening Balance</label>
              <input
                id="OpeningBal"
                type="number"
                name="OpeningBal"
                placeholder="0.00"
                value={formData.OpeningBal || ""}
                onChange={handleChange}
              />
            </div>

            {/* Open Balance Type */}
            <div className="update_ledger_field">
              <label htmlFor="OpenBlType">Opening Balance Type</label>
              <select
                id="OpenBlType"
                name="OpenBlType"
                value={formData.OpenBlType || "Dr"}
                onChange={handleChange}
              >
                <option value="Dr">Dr (Debit)</option>
                <option value="Cr">Cr (Credit)</option>
              </select>
            </div>

            {/* Bill by Bill */}
            <div className="update_ledger_field">
              <label htmlFor="BillbyBill">Bill by Bill</label>
              <select
                id="BillbyBill"
                name="BillbyBill"
                value={formData.BillbyBill ? "Yes" : "No"}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    BillbyBill: e.target.value === "Yes",
                  }))
                }
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            {/* Closing Balance */}
            <div className="update_ledger_field">
              <label htmlFor="CL_BALANCE">Closing Balance</label>
              <input
                id="CL_BALANCE"
                type="number"
                name="CL_BALANCE"
                placeholder="0.00"
                value={formData.CL_BALANCE || ""}
                onChange={handleChange}
              />
            </div>

            {/* GST No */}
            <div className="update_ledger_field">
              <label htmlFor="GSTNO">GST Number</label>
              <input
                id="GSTNO"
                type="text"
                name="GSTNO"
                maxLength={15}
                placeholder="15-character GSTIN"
                value={formData.GSTNO || ""}
                onChange={handleChange}
              />
            </div>

            {/* PAN No */}
            <div className="update_ledger_field">
              <label htmlFor="PANNO">PAN Number</label>
              <input
                id="PANNO"
                type="text"
                name="PANNO"
                placeholder="e.g. ABCDE1234F"
                value={formData.PANNO || ""}
                onChange={handleChange}
              />
            </div>

            {/* Mobile */}
            <div className="update_ledger_field">
              <label htmlFor="MOBILE">Mobile Number</label>
              <input
                id="MOBILE"
                type="text"
                name="MOBILE"
                placeholder="10-digit mobile"
                value={formData.MOBILE || ""}
                onChange={handleChange}
              />
            </div>

            {/* Phone */}
            <div className="update_ledger_field">
              <label htmlFor="PHONE">Phone Number</label>
              <input
                id="PHONE"
                type="text"
                name="PHONE"
                placeholder="Landline / Alt Phone"
                value={formData.PHONE || ""}
                onChange={handleChange}
              />
            </div>

            {/* Email */}
            <div className="update_ledger_field">
              <label htmlFor="EMAIL">Email Address</label>
              <input
                id="EMAIL"
                type="email"
                name="EMAIL"
                placeholder="name@example.com"
                value={formData.EMAIL || ""}
                onChange={handleChange}
              />
            </div>

            {/* Address 1 */}
            <div className="update_ledger_field full_width">
              <label htmlFor="ADDRESS1">Address Line 1</label>
              <textarea
                id="ADDRESS1"
                name="ADDRESS1"
                rows="2"
                placeholder="Street address, building, area..."
                value={formData.ADDRESS1 || ""}
                onChange={handleChange}
              />
            </div>

            {/* Address 2 */}
            <div className="update_ledger_field full_width">
              <label htmlFor="ADDRESS2">Address Line 2</label>
              <textarea
                id="ADDRESS2"
                name="ADDRESS2"
                rows="2"
                placeholder="City, District, Pincode..."
                value={formData.ADDRESS2 || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="update_ledger_actions">
            <Link to="/ShowLedger" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Updating..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateLedger;

